import { useTranslation } from "react-i18next";
import "../../../i18n";
import { useDocumentLegs } from "../../../api/queries";
import { OutcomeBody } from "./bodies/OutcomeBody";

export function OutcomePanel({ docId }: { docId: string }) {
  const { t } = useTranslation();
  const legs = useDocumentLegs(docId);

  return (
    <section className="card">
      <div className="card-head">
        <h2 className="grow">{t("documents.inspector.outcome.title", "Outcome")}</h2>
      </div>
      <OutcomeBody legs={legs.data} isError={legs.isError} />
    </section>
  );
}
